module.exports = __webpack_public_path__ + "static/img/industry_education.7c993d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_education.jpg
// module id = bCtD
// module chunks = 0